<template>
  <el-upload
    v-bind="$attrs"
    v-on="$listeners"
    class="section-upload"
    :multiple="false"
    :action="actionUpload"
    :show-file-list="false"
    ref="upload"
    name="file"
    accept=".xlsx,.xls,.csv"
    :file-list="fileList"
    :on-error="handleError"
    :on-change="handleChange"
    :before-upload="beforeUpload"
    :on-success="handleSuccess"
    :auto-upload="true"
  >
  <el-button type="primary" icon="el-icon-upload" >{{btnText}}</el-button>
  </el-upload>
</template>

<script>
import path from 'path'
export default {
  name: 'baseTableUpload',
  props: {
    actionUrl: {
      type: String,
      default: '/#/'
    },
    btnText: {
      type: String,
      default: '导入Excel'
    }
  },
  data () {
    return {
      formUpload: {
        fileName: ''
      },
      dialogLoading: '',
      fileList: []
    }
  },
  computed: {
    actionUpload () {
      var url = process.env.NODE_ENV === 'production' ? process.env.VUE_APP_BASE_URL + this.actionUrl : path.join('/api/', this.actionUrl)
      return url
    }
  },
  components: {},
  watch: {

  },
  created () {
  },
  methods: {
    handleError () {
      this.fileList = []
      this.formUpload.fileName = ''
      this.$refs.upload.clearFiles()
      this.utilAlert('发生未知异常错误，请重新上传!', 'error')
      this.btnLoading = false
      this.dialogLoading && this.dialogLoading.close()
    },
    handleSuccess (res) {
      this.btnLoading = false
      this.$refs.upload.clearFiles()
      this.formUpload.fileName = ''
      this.fileList = []
      if (res.errcode === 0) {
        this.utilAlert('上传成功', 'success')
        this.$emit('fileUploadSuccess')
      } else {
        this.utilAlert(res.message || '操作失败，请重新上传', 'error')
      }
      this.dialogLoading && this.dialogLoading.close()
    },
    handleChange (file, fileList) {
      if (fileList.length <= 0) {
        return false
      }
      if (!this.handlerFileAccept(file)) {
        return false
      }
      this.fileList[0] = file
      this.formUpload.fileName = this.fileList[0] && this.fileList[0].name
    },
    beforeUpload (file) {
      if (!this.handlerFileAccept(file)) {
        return false
      }
      this.dialogLoading = this.$loading({
        lock: true,
        text: '上传中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      return true
    },
    handlerFileAccept (file) {
      let allow = ['xls', 'xlsx', 'csv']
      let tips = '文件格式不正确,仅支持xls、xlsx、csv文件'
      let suffix = file.name.substr(file.name.lastIndexOf('.') + 1)
      let isAllow = allow.filter(item => item === suffix)
      if (isAllow.length <= 0) {
        this.fileList[0] = ''
        this.formUpload.fileName = ''
        this.utilAlert(tips, 'warning')
        return false
      } else {
        return true
      }
    },
    utilAlert (str, type) {
      this.$message({
        message: str,
        type: type
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.section-upload{
  display: inline-block;
  margin: 0 10px
}
</style>
